import React from 'react';

const PageTwo = (props) => {

  return (
    <div className="kids-quiz__page">
      <div className="kids-quiz__question ui">
        <p className="question__title">{props.goalsQuestion.question}</p>
        <div className="answers-row--flex">
          {props.renderGoalAnswers}
        </div>
      </div>
      <div className={`next-page ${props.activeGoalsAnswer.length !== 0 ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('2')}>Continue</div>
    </div>
  );
}

export default PageTwo;